// Si este archivo ya esta subido (4.9, CA10, D8).
//
// **Por que hace falta preguntarlo.** La tarifa del mes se sube cada mes con el
// mismo nombre de archivo, y hasta el 2026-09-23 quedaban dos documentos
// iguales sin que nadie lo notara: el agente respondia con los dos y no habia
// forma de saber cual era el bueno. Pasa mas todavia desde que se ve que el
// panel sigue trabajando —quien cree que se ha colgado vuelve a pulsar—.
//
// Se compara el **nombre del archivo**, no el titulo: el titulo cambia al
// archivarlo -de `tarifa-sept.txt` a «Tarifas de septiembre 2026»- y entonces
// la misma subida dejaria de reconocerse a si misma.

import type { ApiDocument } from '@/lib/types'

const basename = (ruta: string) => ruta.split('/').pop() ?? ruta

/** El documento que ya tiene este archivo, si lo hay. */
export function sameFileAlreadyUp(
  documents: ApiDocument[],
  fileName: string,
): ApiDocument | null {
  const buscado = fileName.toLowerCase()
  return (
    documents.find((one) => one.file && basename(one.file).toLowerCase() === buscado) ?? null
  )
}
